class SellingPlanWidget extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.sellingPlanInput();
  }
  sellingPlanInput() {
    const inputChecked = this.querySelector('.selling-plan-container input:checked');
    const allSellingPlanRadioOptions = this.querySelectorAll(
      '.selling-plan-container .selling-plan-option.radio-option'
    );
    const planFrequencies = this.querySelectorAll('.plan-frequencies');
    planFrequencies.forEach((freqOption) => {
      freqOption.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        freqOption.classList.toggle('active');
      });
    });

    // document.addEventListener("click",function(e))

    this.querySelectorAll('.plan-freq').forEach((planFreq) => {
      planFreq.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        allSellingPlanRadioOptions.forEach((option) => {
          if (option.dataset.optionId === this.dataset.planFreq) {
            option.querySelector('input.selling-plan-radio')?.click();
          }
        });
      });
    });
    if (inputChecked) {
      const inputs = this.querySelectorAll('.selling-plan-container input');
      const $this = this;
      inputs.forEach((input) => {
        input.addEventListener('change', function () {
          if ($this.closest('.product').querySelector('.button-price')) {
            $this.closest('.product').querySelector('.button-price').textContent = input.dataset.price;
          }
          if ($this.closest('.product').querySelector('[name="selling_plan"]')) {
            $this.closest('.product').querySelector('[name="selling_plan"]').value = input.value;
          }
          let currentOption = this.closest('.selling-plan-option');
          if (currentOption) {
            allSellingPlanRadioOptions.forEach((option) => {
              if (currentOption.classList.value.includes('radio-option')) {
                if (option.dataset.optionId == currentOption.dataset.optionId) {
                  option.classList.remove('hidden');
                } else {
                  option.classList.remove('is-selected');
                  option.classList.add('hidden');
                }
              } else {
                option.classList.remove('is-selected');
              }
            });
          }
          currentOption.classList.add('is-selected');
          if ($this.closest('.product-info')) {
            if (
              $this
                .closest('.product-info')
                .querySelector(".buy-buttons button[type='submit'] [data-selected-variant-price]")
            ) {
              $this
                .closest('.product-info')
                .querySelector(".buy-buttons button[type='submit'] [data-selected-variant-price]").textContent =
                input.dataset.price;
            }
          }
          planFrequencies.forEach((freqOption) => {
            freqOption.classList.remove('active');
          });
          if ($this.querySelector('.js-current-subscription')) {
            $this.querySelector('.js-current-subscription').innerHTML = this.dataset.subscription;
          }
          if (
            document.querySelector(
              '.product-info .product-info__buy-buttons .buy-buttons button[type="submit"] .js-selected-plan-price'
            )
          ) {
            document.querySelector(
              '.product-info .product-info__buy-buttons .buy-buttons button[type="submit"] .js-selected-plan-price'
            ).innerHTML = this.dataset.price;
          }
        });
      });
      inputChecked.dispatchEvent(new Event('change'));
    } else {
      console.log('input checked not found');
    }
  }
}

customElements.define('selling-plan-widget', SellingPlanWidget);
